export const column = () => (
  <path
    d="M9 3V21M15 3V21M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
